/**
 * EventPlannerSlider
 *
 * Purpose: handle events to toggle planner visibility
 */
var EventPlannerSlider = function() {};

EventPlannerSlider.prototype = {
  openers : null,
  sidebar : null,
  canvas : null,
  body : null,
  close : null,
  isTransitionEnd : true,
  init : function() {
    // multiple buttons can toggle the planner
    this.openers = document.querySelectorAll('button.toggle-planner');
    this.close = document.getElementById('planner-close');
    this.sidebar = document.getElementById('planner').parentElement;
    this.canvas = document.getElementById('document-canvas');
    this.body = document.querySelector('body');
    return this;
  },

  /**
   * Toggle planner open/close
   */
  handle : function() {

    var _self = this;

    this.openers.forEach(
      function(btn) {
        // an opener button will planner open or closed
        btn.addEventListener(
          'click',
          function(e) {
            _self.togglePlanner(e);
          }
        );
      }
    );

    // Handle when the transition ends
    var transitionEnd = function(e) {
        e.stopPropagation();
        _self.isTransitionEnd = true;
        if(_self.canvas.classList.contains("closing") || _self.sidebar.classList.contains("closing")){
            _self.canvas.classList.remove("open", "closing");
            _self.sidebar.classList.remove("open", "closing");
        }
    };

    this.canvas.addEventListener('transitionend', transitionEnd);
    this.canvas.addEventListener('webkitTransitionEnd', transitionEnd);
    this.canvas.addEventListener('oTransitionEnd', transitionEnd);
    this.canvas.addEventListener('MSTransitionEnd', transitionEnd);
    this.sidebar.addEventListener('transitionend', transitionEnd);
    this.sidebar.addEventListener('webkitTransitionEnd', transitionEnd);
    this.sidebar.addEventListener('oTransitionEnd', transitionEnd);
    this.sidebar.addEventListener('MSTransitionEnd', transitionEnd);

  },

  canvasCloser : function(e) {
    var _self = this;
    var closer = function(e) { _self.closePlanner(e); };
    this.canvas.addEventListener( 'click', closer, { once: true } );
    this.close.addEventListener( 'click', closer, { once: true } );
  },

  // close the planner
  closePlanner : function(e) {
    e.stopPropagation();
    this.isTransitionEnd = false;
    this.sidebar.classList.add('closing');
    this.canvas.classList.add('closing');
    this.body.classList.remove('overflow-hidden');
  },

  togglePlanner : function(e) {
    e.stopPropagation();
    if(!this.isTransitionEnd) {
      return;
    }
    this.isTransitionEnd = false;
    if(!this.sidebar.classList.contains('open')) {
      this.sidebar.classList.add('open');
      this.canvas.classList.add('open');
      this.body.classList.add('overflow-hidden');
      // bind canvas close
      this.canvasCloser(e);
    } else {
      this.closePlanner(e);
    }
  }

};
